import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UtilityService } from '../../services';

@Component({
  selector: 'app-textarea-field',
  templateUrl: './global-textarea.component.html'
})
export class GlobalTextareaComponent {

  @Input() label: string;
  @Input() maxlength = '';
  @Input() hint?: string;
  @Input() placeholder?: string;
  @Input() control: FormControl;
  @Input() tooltip;

  constructor(private util: UtilityService) { }

  isRequired() {
    return this.util.isRequired(this.control);
  }
}
